import type {Location, Office} from './shared'

export interface State {
    location: Location | ''
    office: Office | ''
    healthcareAndWellbeing: number
    leaveDays: number
    charityAndDonations: number
    homeOfficeSetup: number
    learningAndDevelopment: number
    artsCultureEntertainment: number
    lifestyleTravelAndTransport: number
    yourFamily: number
}

export enum ActionType {
    LOCATION_UPDATED,
    OFFICE_UPDATED,
    HEALTHCARE_AND_WELLBEING_UPDATED,
    LEAVE_DAYS_UPDATED,
    CHARITY_AND_DONATIONS_UPDATED,
    HOME_OFFICE_SETUP_UPDATED,
    LEARNING_AND_DEVELOPMENT_UPDATED,
    ARTS_CULTURE_ENTERTAINMENT_UPDATED,
    LIFESTYLE_TRAVEL_AND_TRANSPORT_UPDATED,
    YOUR_FAMILY_UPDATED,
}

export type Action =
    | {
          type: ActionType.LOCATION_UPDATED
          location: Location
      }
    | {
          type: ActionType.OFFICE_UPDATED
          office: Office
      }
    | {
          type: ActionType.HEALTHCARE_AND_WELLBEING_UPDATED
          value: number
      }
    | {
          type: ActionType.LEAVE_DAYS_UPDATED
          value: number
      }
    | {
          type: ActionType.CHARITY_AND_DONATIONS_UPDATED
          value: number
      }
    | {
          type: ActionType.HOME_OFFICE_SETUP_UPDATED
          value: number
      }
    | {
          type: ActionType.LEARNING_AND_DEVELOPMENT_UPDATED
          value: number
      }
    | {
          type: ActionType.ARTS_CULTURE_ENTERTAINMENT_UPDATED
          value: number
      }
    | {
          type: ActionType.LIFESTYLE_TRAVEL_AND_TRANSPORT_UPDATED
          value: number
      }
    | {
          type: ActionType.YOUR_FAMILY_UPDATED
          value: number
      }

export const initialState: State = {
    location: '',
    office: '',
    healthcareAndWellbeing: 0,
    leaveDays: 0,
    charityAndDonations: 0,
    homeOfficeSetup: 0,
    learningAndDevelopment: 0,
    artsCultureEntertainment: 0,
    lifestyleTravelAndTransport: 0,
    yourFamily: 0,
}

export const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case ActionType.LOCATION_UPDATED:
            return {
                // Reset sliders to initial state when location is updated
                ...initialState,
                location: action.location,
                office: '',
            }
        case ActionType.OFFICE_UPDATED:
            return {
                // Reset sliders to initial state when office is updated
                ...initialState,
                location: state.location,
                office: action.office,
            }
        case ActionType.HEALTHCARE_AND_WELLBEING_UPDATED:
            return {
                ...state,
                healthcareAndWellbeing: action.value,
            }
        case ActionType.LEAVE_DAYS_UPDATED:
            return {
                ...state,
                leaveDays: action.value,
            }
        case ActionType.CHARITY_AND_DONATIONS_UPDATED:
            return {
                ...state,
                charityAndDonations: action.value,
            }
        case ActionType.HOME_OFFICE_SETUP_UPDATED:
            return {
                ...state,
                homeOfficeSetup: action.value,
            }
        case ActionType.LEARNING_AND_DEVELOPMENT_UPDATED:
            return {
                ...state,
                learningAndDevelopment: action.value,
            }
        case ActionType.ARTS_CULTURE_ENTERTAINMENT_UPDATED:
            return {
                ...state,
                artsCultureEntertainment: action.value,
            }
        case ActionType.LIFESTYLE_TRAVEL_AND_TRANSPORT_UPDATED:
            return {
                ...state,
                lifestyleTravelAndTransport: action.value,
            }
        case ActionType.YOUR_FAMILY_UPDATED:
            return {
                ...state,
                yourFamily: action.value,
            }
        default:
            throw new Error('Unrecognized action')
    }
}
